var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.formList, function (item, index) {
        return _c("div", { key: index }, [
          item.formField.fieldName == "描述" && !item.formField.type
            ? _c("div", { staticClass: "info" }, [
                _c(
                  "div",
                  { staticClass: "info_key" },
                  [
                    _c(
                      "div",
                      { staticStyle: { color: "#ff4d42", width: "11px" } },
                      [
                        item.formField.nullFlage == "1"
                          ? _c("span", [_vm._v("*")])
                          : _vm._e(),
                      ]
                    ),
                    _c("i", {
                      staticClass: "iconfont icon-describe info_icon",
                      staticStyle: { "font-size": "14px" },
                    }),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: "描述",
                          placement: "bottom",
                          "popper-class": "texttooltip",
                          "open-delay": 500,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.permissionsChange1("describe")
                              },
                            },
                          },
                          [_vm._v("描述")]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm.drawer.info.editFlag &&
                _vm.drawer.delFlag != "2" &&
                _vm.drawer.info.status != "2" &&
                _vm.edit_input == "describe"
                  ? _c(
                      "div",
                      {
                        staticStyle: { width: "calc(100% - 104px)" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.permissionsChange1("describe")
                          },
                        },
                      },
                      [
                        _c("Describe", {
                          attrs: {
                            describes: _vm.drawer.describes,
                            "form-data": item,
                          },
                          on: { func: _vm.addtask },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        class:
                          _vm.drawer.info.editFlag &&
                          _vm.drawer.info.status != "2"
                            ? "info_valueEditFlag"
                            : "info_value",
                        staticStyle: {
                          "min-height": "35px",
                          cursor: "pointer",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.permissionsChange1("describe")
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "info_value_text",
                            staticStyle: { "margin-top": "2px" },
                          },
                          [
                            _c("div", [
                              _vm.drawer.describes.describe
                                ? _c(
                                    "div",
                                    {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$httpFormart(
                                            _vm.drawer.describes.describe
                                          )
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.drawer.describes.describe)
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "file_list" },
                                _vm._l(
                                  _vm.drawer.describes.descList,
                                  function (key, index_key) {
                                    return _c(
                                      "div",
                                      {
                                        key: index_key,
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.previewFile(key)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "iconfont icon-wenjian file__icon",
                                        }),
                                        _c("span", [
                                          _vm._v(_vm._s(key.fileName)),
                                        ]),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
              ])
            : item.formField.fieldName == "标签" && !item.formField.type
            ? _c("div", { staticClass: "info" }, [
                _c(
                  "div",
                  { staticClass: "info_key" },
                  [
                    _c(
                      "div",
                      { staticStyle: { color: "#ff4d42", width: "11px" } },
                      [
                        item.formField.nullFlage == "1"
                          ? _c("span", [_vm._v("*")])
                          : _vm._e(),
                      ]
                    ),
                    _c("i", { staticClass: "iconfont icon-tag info_icon" }),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: "标签",
                          placement: "bottom",
                          "popper-class": "texttooltip",
                          "open-delay": 500,
                        },
                      },
                      [_c("div", [_vm._v("标签")])]
                    ),
                  ],
                  1
                ),
                !_vm.drawer.info.editFlag ||
                _vm.drawer.delFlag == "2" ||
                _vm.drawer.info.status == "2"
                  ? _c("div", { staticClass: "info_value" }, [
                      _vm.drawer.info.labelList &&
                      _vm.drawer.info.labelList.length > 0
                        ? _c(
                            "div",
                            { staticClass: "info_box" },
                            _vm._l(
                              _vm.drawer.info.labelList,
                              function (tag, index1) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: index1,
                                    staticStyle: { "margin-right": "16px" },
                                    style:
                                      "color:" +
                                      tag.color +
                                      ";background:" +
                                      _vm.convertHex(tag.color, 10),
                                    attrs: { type: "warning" },
                                  },
                                  [_vm._v(_vm._s(tag.labelName))]
                                )
                              }
                            ),
                            1
                          )
                        : _vm._e(),
                    ])
                  : _c("div", { staticClass: "info_value" }, [
                      _c(
                        "div",
                        {
                          staticClass: "info_box",
                          staticStyle: { "margin-left": "11px" },
                        },
                        [
                          _vm._l(
                            _vm.drawer.info.labelList,
                            function (tag, index1) {
                              return _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.drawer.info.labelList &&
                                        _vm.drawer.info.labelList.length > 0,
                                      expression:
                                        "drawer.info.labelList && drawer.info.labelList.length > 0",
                                    },
                                  ],
                                  key: index1,
                                  staticClass: "info_tags",
                                },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      staticStyle: { "margin-right": "16px" },
                                      style:
                                        "color:" +
                                        tag.color +
                                        ";background:" +
                                        _vm.convertHex(tag.color, 10),
                                      attrs: { type: "warning" },
                                    },
                                    [_vm._v(_vm._s(tag.labelName))]
                                  ),
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-shanchu del_icon",
                                    on: {
                                      click: function ($event) {
                                        return _vm.delTagsChange(tag)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "bottom",
                                width: "540",
                                trigger: "click",
                                "popper-class": "popover_tags",
                                "visible-arrow": false,
                              },
                            },
                            [
                              _c("TagsList", {
                                attrs: {
                                  "tags-objects": _vm.tagsObject,
                                  "tag-lists": _vm.tagList,
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "iconfont icon-jiahao2fill add_icon",
                                style:
                                  _vm.drawer.info.labelList &&
                                  _vm.drawer.info.labelList.length > 0
                                    ? "margin: 0 24px;"
                                    : "margin: 0",
                                attrs: { slot: "reference" },
                                on: { click: _vm.getTabsList },
                                slot: "reference",
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ]),
              ])
            : _c("div", { staticClass: "info" }, [
                _c(
                  "div",
                  { staticClass: "info_key" },
                  [
                    _c(
                      "div",
                      { staticStyle: { color: "#ff4d42", width: "11px" } },
                      [
                        item.formField.nullFlage == "1"
                          ? _c("span", [_vm._v("*")])
                          : _vm._e(),
                      ]
                    ),
                    _c("i", {
                      staticClass: "iconfont info_icon",
                      class: {
                        "icon-a-01": item.formField.type == "0",
                        "icon-a-02beifen": item.formField.type == "1",
                        "icon-a-02": item.formField.type == "2",
                        "icon-a-02beifen2": item.formField.type == "3",
                        "icon-a-02beifen3": item.formField.type == "4",
                        "icon-bianzu": item.formField.type == "5",
                        "icon-danxuan": item.formField.type == "6",
                        "icon-a-02beifen5": item.formField.type == "7",
                        "icon-a-02beifen7": item.formField.type == "8",
                        "icon-a-02beifen8": item.formField.type == "9",
                        "icon-a-02beifen9": item.formField.type == "10",
                        "icon-a-02beifen10": item.formField.type == "11",
                        "icon-xiangji1": item.formField.type == "17",
                      },
                    }),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "dark",
                          content: item.formField.fieldName,
                          placement: "bottom",
                          "popper-class": "texttooltip",
                          "open-delay": 500,
                        },
                      },
                      [
                        item.formField.type == "0" || item.formField.type == "1"
                          ? _c(
                              "div",
                              {
                                staticClass: "form_fieldName",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.permissionsChange(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.formField.fieldName))]
                            )
                          : item.formField.type == "2"
                          ? _c(
                              "div",
                              {
                                staticClass: "form_fieldName",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.permissionsChange(
                                      item,
                                      "describe"
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.formField.fieldName))]
                            )
                          : _c("div", { staticClass: "form_fieldName" }, [
                              _vm._v(_vm._s(item.formField.fieldName)),
                            ]),
                      ]
                    ),
                  ],
                  1
                ),
                item.formField.type == "0" || item.formField.type == "1"
                  ? _c("div", { staticClass: "info_value" }, [
                      _vm.drawer.info.editFlag &&
                      _vm.drawer.delFlag != "2" &&
                      _vm.drawer.info.status != "2" &&
                      _vm.edit_input == item.id
                        ? _c(
                            "div",
                            {
                              staticStyle: { width: "100%" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item)
                                },
                              },
                            },
                            [
                              item.formField.type == "0"
                                ? _c(
                                    "div",
                                    [
                                      _c("el-input", {
                                        ref: item.id,
                                        refInFor: true,
                                        attrs: {
                                          autofocus: true,
                                          placeholder: "点击添加",
                                        },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.editFormData(
                                              item,
                                              item.fieldValue
                                            )
                                          },
                                        },
                                        model: {
                                          value: item.fieldValue,
                                          callback: function ($$v) {
                                            _vm.$set(item, "fieldValue", $$v)
                                          },
                                          expression: "item.fieldValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              item.formField.type == "1"
                                ? _c(
                                    "div",
                                    [
                                      _c("el-input", {
                                        ref: item.id,
                                        refInFor: true,
                                        attrs: {
                                          type: "'number",
                                          autofocus: true,
                                          placeholder: "点击添加",
                                          oninput:
                                            "if(isNaN(value)) { value = parseFloat(value) } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.numValue(item)
                                          },
                                          blur: function ($event) {
                                            return _vm.editFormData(
                                              item,
                                              item.fieldValue
                                            )
                                          },
                                        },
                                        model: {
                                          value: item.fieldValue,
                                          callback: function ($$v) {
                                            _vm.$set(item, "fieldValue", $$v)
                                          },
                                          expression: "item.fieldValue",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _c(
                            "div",
                            {
                              class: _vm.drawer.info.editFlag
                                ? "info_valueEditFlag_text"
                                : "info_value_text",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.fieldValue))]
                          ),
                    ])
                  : item.formField.type == "2"
                  ? _c("div", { staticClass: "info_value" }, [
                      (_vm.drawer.info.editFlag &&
                        _vm.drawer.delFlag != "2" &&
                        _vm.drawer.info.status != "2" &&
                        _vm.edit_input == item.id) ||
                      _vm.isUpladRunning === item.id
                        ? _c(
                            "div",
                            {
                              staticStyle: { width: "100%" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item, "describe")
                                },
                              },
                            },
                            [
                              _c("Describe", {
                                attrs: {
                                  describes: item.describes,
                                  "form-data": item,
                                },
                                on: { func: _vm.addDescs },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              class: _vm.drawer.info.editFlag
                                ? "info_valueEditFlag"
                                : "info_value",
                              staticStyle: {
                                "min-height": "35px",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item, "describe")
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "info_value_text",
                                  staticStyle: { "margin-top": "2px" },
                                },
                                [
                                  _c("div", [
                                    item.describes.describe
                                      ? _c(
                                          "div",
                                          {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$httpFormart(
                                                  item.describes.describe
                                                )
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.describes.describe)
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "file_list" },
                                      _vm._l(
                                        item.describes.descList,
                                        function (key, index_key) {
                                          return _c(
                                            "div",
                                            {
                                              key: index_key,
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.previewFile(key)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "iconfont icon-wenjian file__icon",
                                              }),
                                              _c("span", [
                                                _vm._v(_vm._s(key.fileName)),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                    ])
                  : item.formField.type == "3"
                  ? _c(
                      "div",
                      {
                        class: _vm.drawer.info.editFlag
                          ? "info_valueEditFlag"
                          : "info_value",
                      },
                      [
                        _vm.uploadType === "ding"
                          ? _c(
                              "div",
                              {
                                staticStyle: { width: "100%" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.permissionsChange(item)
                                  },
                                },
                              },
                              [
                                _vm.drawer.info.editFlag &&
                                _vm.drawer.delFlag != "2" &&
                                _vm.drawer.info.status != "2"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "uploadfile",
                                        staticStyle: {
                                          width: "calc(100% - 11px)",
                                          "margin-left": "11px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.uploadFile(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "iconfont icon-a-02beifen2 file_icon",
                                        }),
                                        _c("span", { staticClass: "test" }, [
                                          _vm._v("附件"),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                                item.files && item.files.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "file_lists" },
                                      _vm._l(
                                        item.files,
                                        function (file, index_file) {
                                          return _c(
                                            "div",
                                            {
                                              key: index_file,
                                              staticClass: "file_boxs",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "file_text",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.previewFile(
                                                        file
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icon-wenjian file__icon",
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(file.fileName)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm.drawer.info.editFlag &&
                                              _vm.drawer.delFlag != "2" &&
                                              _vm.drawer.info.status != "2"
                                                ? _c("i", {
                                                    staticClass:
                                                      "iconfont icon-shanchu1 del__icon",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.delFun(
                                                          file,
                                                          index_file,
                                                          item
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm.uploadType === "oss"
                          ? _c(
                              "div",
                              {
                                staticStyle: { width: "100%" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.permissionsChange(item)
                                  },
                                },
                              },
                              [
                                _c("multi-upload", {
                                  attrs: {
                                    "file-data": {
                                      objectType: "3",
                                      objectId: _vm.drawer.info.id,
                                      type: "15",
                                      proId: _vm.drawer.info.id,
                                      source: "oss",
                                      fieldId: item.formField.id,
                                    },
                                    "upload-btn": _vm.uploadBtn,
                                  },
                                  on: { setFileList: _vm.successFile },
                                }),
                                item.files && item.files.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "file_lists" },
                                      _vm._l(
                                        item.files,
                                        function (file, index_file) {
                                          return _c(
                                            "div",
                                            {
                                              key: index_file,
                                              staticClass: "file_boxs",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "file_text",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.previewFile(
                                                        file
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "iconfont icon-wenjian file__icon",
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(file.fileName)
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm.drawer.info.editFlag &&
                                              _vm.drawer.delFlag != "2" &&
                                              _vm.drawer.info.status != "2"
                                                ? _c("i", {
                                                    staticClass:
                                                      "iconfont icon-shanchu1 del__icon",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.delFun(
                                                          file,
                                                          index_file,
                                                          item
                                                        )
                                                      },
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  : item.formField.type == "4"
                  ? _c("div", { staticClass: "info_value" }, [
                      _vm.drawer.info.editFlag &&
                      _vm.drawer.delFlag != "2" &&
                      _vm.drawer.info.status != "2" &&
                      _vm.edit_input == item.id
                        ? _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item)
                                },
                              },
                            },
                            [
                              _c("el-date-picker", {
                                ref: item.id,
                                refInFor: true,
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择日期时间",
                                  "value-format": "yyyy/MM/dd HH:mm:ss",
                                  format: "yyyy/MM/dd HH:mm:ss",
                                },
                                on: {
                                  blur: function ($event) {
                                    return _vm.editFormData(
                                      item,
                                      item.fieldValue
                                    )
                                  },
                                },
                                model: {
                                  value: item.fieldValue,
                                  callback: function ($$v) {
                                    _vm.$set(item, "fieldValue", $$v)
                                  },
                                  expression: "item.fieldValue",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              class: _vm.drawer.info.editFlag
                                ? "info_valueEditFlag_text"
                                : "info_value_text",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item)
                                },
                              },
                            },
                            [_vm._v(_vm._s(item.fieldValue))]
                          ),
                    ])
                  : item.formField.type == "5"
                  ? _c("div", { staticClass: "info_value" }, [
                      _c(
                        "div",
                        { staticClass: "info_value_text" },
                        [
                          _c("span", [_vm._v(_vm._s(item.addressName))]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: "PC端不支持位置功能，请在手机端选择！",
                                placement: "bottom",
                                "popper-class": "texttooltip",
                                "open-delay": 500,
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-bianzu info_icon",
                                style: item.addressName
                                  ? "margin-left:5px"
                                  : "",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ])
                  : item.formField.type == "17"
                  ? _c("div", { staticClass: "info_value" }, [
                      _c(
                        "div",
                        {
                          staticClass: "info_value_text",
                          staticStyle: { margin: "0" },
                        },
                        [
                          item.files && item.files.length > 0
                            ? _c(
                                "div",
                                { staticClass: "file_lists" },
                                _vm._l(item.files, function (file, index_file) {
                                  return _c(
                                    "div",
                                    {
                                      key: index_file,
                                      staticClass: "file_boxs",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "file_text",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.previewFile(file)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "iconfont icon-wenjian file__icon",
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(file.fileName)),
                                          ]),
                                        ]
                                      ),
                                      _vm.drawer.info.editFlag &&
                                      _vm.drawer.delFlag != "2" &&
                                      _vm.drawer.info.status != "2"
                                        ? _c("i", {
                                            staticClass:
                                              "iconfont icon-shanchu1 del__icon",
                                            on: {
                                              click: function ($event) {
                                                return _vm.delFun(
                                                  file,
                                                  index_file,
                                                  item
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content:
                                      "PC端不支持拍照功能，请在手机端进行拍照！",
                                    placement: "bottom",
                                    "popper-class": "texttooltip",
                                    "open-delay": 500,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "iconfont icon-xiangji1 info_icon",
                                    staticStyle: { "margin-left": "11px" },
                                  }),
                                ]
                              ),
                        ],
                        1
                      ),
                    ])
                  : item.formField.type == "6"
                  ? _c("div", { staticClass: "info_value" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "calc(100% - 11px)",
                            "padding-left": "11px",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function ($event) {
                                  return _vm.editFormData(item, item.fieldValue)
                                },
                              },
                              model: {
                                value: item.fieldValue,
                                callback: function ($$v) {
                                  _vm.$set(item, "fieldValue", $$v)
                                },
                                expression: "item.fieldValue",
                              },
                            },
                            _vm._l(item.formField.optionsArray, function (key) {
                              return _c(
                                "el-radio",
                                { key: key.key, attrs: { label: key.key } },
                                [_vm._v(_vm._s(key.value))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : item.formField.type == "7"
                  ? _c("div", { staticClass: "info_value" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "calc(100% - 11px)",
                            "padding-left": "11px",
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              on: {
                                change: function ($event) {
                                  return _vm.editFormData(item, item.strArray)
                                },
                              },
                              model: {
                                value: item.strArray,
                                callback: function ($$v) {
                                  _vm.$set(item, "strArray", $$v)
                                },
                                expression: "item.strArray",
                              },
                            },
                            _vm._l(item.formField.optionsArray, function (key) {
                              return _c(
                                "el-checkbox",
                                { key: key.key, attrs: { label: key.key } },
                                [_vm._v(_vm._s(key.value))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : item.formField.type == "8"
                  ? _c("div", { staticClass: "info_value" }, [
                      _vm.drawer.info.editFlag &&
                      _vm.drawer.delFlag != "2" &&
                      _vm.drawer.info.status != "2" &&
                      _vm.edit_input == item.id
                        ? _c(
                            "div",
                            {
                              staticStyle: { width: "100%" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item)
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  ref: item.id,
                                  refInFor: true,
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择内容",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.editFormData(
                                        item,
                                        item.fieldValue
                                      )
                                    },
                                  },
                                  model: {
                                    value: item.fieldValue,
                                    callback: function ($$v) {
                                      _vm.$set(item, "fieldValue", $$v)
                                    },
                                    expression: "item.fieldValue",
                                  },
                                },
                                _vm._l(
                                  item.formField.optionsArray,
                                  function (key) {
                                    return _c("el-option", {
                                      key: key.key,
                                      attrs: {
                                        label: key.value,
                                        value: key.key,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              class: _vm.drawer.info.editFlag
                                ? "info_valueEditFlag_text"
                                : "info_value_text",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item)
                                },
                              },
                            },
                            _vm._l(item.formField.optionsArray, function (key) {
                              return _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: key.key == item.fieldValue,
                                      expression: "key.key==item.fieldValue",
                                    },
                                  ],
                                  key: key.key,
                                },
                                [_vm._v(_vm._s(key.value))]
                              )
                            }),
                            0
                          ),
                    ])
                  : item.formField.type == "9"
                  ? _c("div", { staticClass: "info_value" }, [
                      _vm.drawer.info.editFlag &&
                      _vm.drawer.delFlag != "2" &&
                      _vm.drawer.info.status != "2" &&
                      _vm.edit_input == item.id
                        ? _c(
                            "div",
                            {
                              staticStyle: { width: "100%" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item)
                                },
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  ref: item.id,
                                  refInFor: true,
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择内容",
                                    multiple: "",
                                    "collapse-tags": "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.editFormData(
                                        item,
                                        item.strArray
                                      )
                                    },
                                  },
                                  model: {
                                    value: item.strArray,
                                    callback: function ($$v) {
                                      _vm.$set(item, "strArray", $$v)
                                    },
                                    expression: "item.strArray",
                                  },
                                },
                                _vm._l(
                                  item.formField.optionsArray,
                                  function (key) {
                                    return _c("el-option", {
                                      key: key.key,
                                      attrs: {
                                        label: key.value,
                                        value: key.key,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              class: _vm.drawer.info.editFlag
                                ? "info_valueEditFlag_text"
                                : "info_value_text",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.permissionsChange(item)
                                },
                              },
                            },
                            [
                              item.strArray && item.strArray.length > 0
                                ? _c(
                                    "div",
                                    _vm._l(
                                      item.strArray,
                                      function (arr, index_arr) {
                                        return _c(
                                          "span",
                                          { key: index_arr },
                                          _vm._l(
                                            item.formField.optionsArray,
                                            function (key) {
                                              return _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: key.key == arr,
                                                      expression:
                                                        "key.key==arr",
                                                    },
                                                  ],
                                                  key: key.key,
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(key.value)),
                                                  ]),
                                                  index_arr <
                                                  item.strArray.length - 1
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "5px",
                                                          },
                                                        },
                                                        [_vm._v(",")]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                    ])
                  : item.formField.type == "10" || item.formField.type == "11"
                  ? _c("div", { staticClass: "info_value" }, [
                      _vm.drawer.info.editFlag &&
                      _vm.drawer.delFlag != "2" &&
                      _vm.drawer.info.status != "2"
                        ? _c("div", { staticClass: "personnel" }, [
                            item.users && item.users.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      display: "flex",
                                      "align-items": "flex-start",
                                    },
                                  },
                                  [
                                    _c(
                                      "draggable",
                                      {
                                        staticStyle: {
                                          width: "calc(100% - 45px)",
                                        },
                                        attrs: {
                                          group: "responseUsers",
                                          options: {
                                            handle: ".info_personnel1",
                                          },
                                          animation: "500",
                                        },
                                        model: {
                                          value: item.users,
                                          callback: function ($$v) {
                                            _vm.$set(item, "users", $$v)
                                          },
                                          expression: "item.users",
                                        },
                                      },
                                      [
                                        _c(
                                          "transition-group",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-wrap": "wrap",
                                            },
                                          },
                                          _vm._l(
                                            item.users,
                                            function (user, index2) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index2,
                                                  staticStyle: {
                                                    "margin-left": "11px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.contactCh(
                                                        item.users,
                                                        index,
                                                        item.formField.type
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "user_personnel",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info_personnel1",
                                                        },
                                                        [
                                                          user.avatar != "" &&
                                                          user.avatar != null
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "info_personnel_surname1",
                                                                attrs: {
                                                                  src: user.avatar,
                                                                },
                                                              })
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "info_personnel_surname1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        user.name.substring(
                                                                          0,
                                                                          1
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              ),
                                                          _vm.channel ===
                                                          "wechat"
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "ww-open-data",
                                                                    {
                                                                      attrs: {
                                                                        type: "userName",
                                                                        openid:
                                                                          user.name,
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c("div", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    user.name
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      ),
                                                      _c("i", {
                                                        staticClass:
                                                          "iconfont icon-shanchu del_icon",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.delUsers(
                                                              item.users,
                                                              index2,
                                                              index
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("i", {
                                      staticClass:
                                        "iconfont icon-jiahao2fill add_icon",
                                      staticStyle: { margin: "0 24px" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.contactCh(
                                            item.users,
                                            index,
                                            item.formField.type
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("i", {
                                  staticClass:
                                    "iconfont icon-jiahao2fill add_icon",
                                  style:
                                    item.users && item.users.length > 0
                                      ? "margin: 0 24px;"
                                      : "margin: 0 21px;",
                                  on: {
                                    click: function ($event) {
                                      return _vm.contactCh(
                                        item.users,
                                        index,
                                        item.formField.type
                                      )
                                    },
                                  },
                                }),
                          ])
                        : item.users && item.users.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "add_text",
                              staticStyle: { width: "calc(100% - 10px)" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "info_box" },
                                _vm._l(item.users, function (user, index_user) {
                                  return _c(
                                    "div",
                                    {
                                      key: index_user,
                                      staticClass: "info_personnel",
                                    },
                                    [
                                      user.avatar != "" && user.avatar != null
                                        ? _c("img", {
                                            staticClass:
                                              "info_personnel_surname",
                                            attrs: { src: user.avatar },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "info_personnel_surname",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    user.name.substring(0, 1)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                      _vm.channel === "wechat"
                                        ? _c(
                                            "div",
                                            [
                                              _c("ww-open-data", {
                                                attrs: {
                                                  type: "userName",
                                                  openid: user.name,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c("div", [
                                            _vm._v(_vm._s(user.name)),
                                          ]),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
        ])
      }),
      _c("VideoPreview", {
        attrs: { visible: _vm.showVideo, url: _vm.videoUrl },
        on: {
          "update:visible": [
            function ($event) {
              _vm.showVideo = $event
            },
            function (val) {
              return _vm.console.log("visible 更新为:", val)
            },
          ],
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }